const blockCss = `{
  "reject_requests": ["css"]
}`;

export default blockCss;
